import { render, staticRenderFns } from "./DispensationFormFilesDetails.vue?vue&type=template&id=48630880&scoped=true&"
import script from "./DispensationFormFilesDetails.vue?vue&type=script&lang=js&"
export * from "./DispensationFormFilesDetails.vue?vue&type=script&lang=js&"
import style0 from "./DispensationFormFilesDetails.vue?vue&type=style&index=0&id=48630880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48630880",
  null
  
)

export default component.exports